var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconwarning = function SvgIconwarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.707 1.211a.8.8 0 0 0-1.414 0L1.09 28.031a.8.8 0 0 0 .707 1.174h28.406a.8.8 0 0 0 .707-1.174zm-2.442 10.466a1.735 1.735 0 1 1 3.47 0v7.81a1.735 1.735 0 1 1-3.47 0zm0 13.016a1.735 1.735 0 1 1 3.47 0 1.735 1.735 0 0 1-3.47 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconwarning;